<div class="w-12 flex flex-justify-center flex-middle m-t">
    <button [disabled]="status.busy || page <= 1"
            (click)="goToPage(page - 1)"
            class="m-r flex flex-middle">
        <i class="icon-chevron-left  inline-flex"
           [ngClass]="(status.busy || page <= 1)  ? 'col-4' : 'col-1'"
           aria-hidden="true"></i>
    </button>
    @if(page >= numberOfPages && numberOfPages > 2)
    {
    <button class="m-l-1 m-r-1 _custom-button"
            (click)="goToPage(page - 2)"
            [disabled]="status.busy">
        <p class="s1">{{page - 2}}</p>
    </button>
    }
    @if(page > 1){
    <button class="m-l-1 m-r-1 _custom-button"
            (click)="goToPage(page - 1)"
            [disabled]="status.busy">
        <p class="s1">{{page - 1}}</p>
    </button>
    }
    <button class="m-l-1 m-r-1 _custom-button _custom-button-active"
            [disabled]="status.busy">
        <p class="s1">{{page}}</p>
    </button>
    @if(page < numberOfPages)
      {
      <button
      class="m-l-1 m-r-1 _custom-button"
      (click)="goToPage(page + 1)"
      [disabled]="status.busy">
        <p class="s1">{{page + 1}}</p>
        </button>
        }
        @if(page <= 1
           &&
           numberOfPages> 2)
            {
            <button class="m-l-1 m-r-1 _custom-button"
                    (click)="goToPage(page + 2)"
                    [disabled]="status.busy">
                <p class="s1">{{page + 2}}</p>
            </button>
            }
            <button [disabled]="status.busy || page >= numberOfPages"
                    (click)="goToPage(page + 1)"
                    class="m-l flex flex-middle">
                <i class="icon-chevron-right  inline-flex"
                   [ngClass]="(status.busy || page >= numberOfPages) ? 'col-4' : 'col-1'"
                   aria-hidden="true"></i></button>
</div>
<result class="w-12 flex flex-justify-center m-t"
        [status]="status"></result>